// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateIndiaAddress(addressValue: string): ?UserInputValidationError {
  return addressValue && addressValue.length >= 3 ? undefined : { id: 'min-length' };
}
